/**
 * Returns the base URL without query parameters.
 * @param {string} url - The full URL
 * @returns {string} The URL without query parameters
 */
const getBaseUrl = url => {
    const parsedUrl = new URL(url);
    parsedUrl.search = '';
    return parsedUrl.toString();
};

export default getBaseUrl;
